import { Injectable } from '@angular/core';
import { interval, Subject, switchMap, startWith, takeUntil, filter } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';

@Injectable({ providedIn: 'root' })
export class SessionService {

  private readonly destroy$ = new Subject<void>();
  private started = false;

  constructor(
    private userService: UserService
  ) {}

  /**
   * Avvia il keep-alive sessione
   */
  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    this.userService.user$
      .pipe(
        filter(Boolean),   // solo se loggato
        takeUntil(this.destroy$),
        switchMap(() =>
          interval(120_000).pipe(
            startWith(0),
            switchMap(() => this.userService.alive())
          )
        )
      )
      .subscribe({
        error: () => {
          // opzionale: logout forzato
          this.stop();
        }
      });
  }
 
  stop(): void {
    this.destroy$.next();
    this.started = false;
  }
}
